import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { environment } from '../../environments/environment';

/**
 * Proxy auth guard that wraps Auth0's AuthGuard.
 * When auth is disabled (local or test environments), it allows all routes.
 * Otherwise, it delegates to Auth0's AuthGuard for authentication.
 */
export const proxyAuthGuard: CanActivateFn = (route, state) => {
    // Disable auth for local and test environments
    if (environment.stage === 'local' || environment.stage === 'test') {
        return true;
    }

    // For other environments, use Auth0's authentication
    const authGuard = inject(AuthGuard);
    return authGuard.canActivate(route, state);
};
